module.exports = __webpack_public_path__ + "static/038a0dc33d4dac47f778f0ea232be20f4384e2cd41e385d7c1b8ea7271a05bf2-d0a5fdbb97bf02effb238c86824013da.png";